import { createSlice } from '@reduxjs/toolkit'

export const appCommonSlice = createSlice({
  name: 'appCommonSlice',
  initialState: {
    erp: '', // 用户erp
    erpEncrypted: '', // 用户加密erp
    timeStamp: '', // 用户请求时间戳
    safetyToken: '', // 安全秘钥
    contacts: [], // 无权限联系人列表
    isIOS: false, // 是否是IOS设备
    isPC: false, // 是否使用PC样式
    firstMenuList: [], // 用户菜单权限
    secondMenuMap: {}, // 二级菜单
    regionList: [], // 省区列表
    commonRegion: {}, // 省区选择
    commonTime: {} // 日期选择
  },
  reducers: {
    setIsIOS: (state, action) => {
      state.isIOS = action.payload
    },
    setIsPC: (state, action) => {
      state.isPC = action.payload
    },
    setStroeDemo: (state, action) => {
      state.dataName = action.payload
    },
    // 获取用户加密信息
    setErpEncrypted: (state, action) => {
      state.erpEncrypted = action.payload
    },
    // 获取用户信息
    setErp: (state, action) => {
      state.erp = action.payload
    },
    // 获取菜单列表
    setQueryMenuList: (state, action) => {
      const { firstMenuList, secondMenuMap } = action.payload
      state.firstMenuList = firstMenuList
      state.secondMenuMap = secondMenuMap
    },
    // 获取省区列表
    setQueryRegionList: (state, action) => {
      state.regionList = action.payload
    },
    // 获取选择省区
    setCommonRegion: (state, action) => {
      state.commonRegion = action.payload
    },
    // 获取日期选择
    setCommonTime: (state, action) => {
      state.commonTime = action.payload
    }
  }
})

export const {
  setStroeDemo,
  setErpEncrypted,
  setErp,
  setIsIOS,
  setIsPC,
  setQueryMenuList,
  setQueryRegionList,
  setCommonRegion,
  setCommonTime
} = appCommonSlice.actions

export default appCommonSlice.reducer
